
import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

const applicationServerKey = 'BDvSWov7z-IKx3-Ri4zdg6q8dNCu2PsFxELYX4lSO3E3R27_SEvfeTDSVv6E1ev_sVxDGTNf_v1IQSV2RggqSm0';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeUserToPush() {
  if ('Notification' in window && 'serviceWorker' in navigator) {
    const reg = await navigator.serviceWorker.register('/service-worker-custom.js');
    await navigator.serviceWorker.ready;
    if (Notification.permission !== 'granted') {
      console.warn('Permission for notifications was denied');
      return;
    }
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
    });
    // Формируем данные для django-push-notifications
    const data = {
      registration_id: sub.endpoint,
      p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('p256dh')))),
      auth: btoa(String.fromCharCode.apply(null, new Uint8Array(sub.getKey('auth')))),
    };
    console.log('Push subscription data:', data);
    const endpoint = `${backendUrl}/api/notifications/web-push/push/web/`;
    await fetchWithAuth(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  }
}

export async function unsubscribeUserFromPush() {
  if ('serviceWorker' in navigator) {
    const reg = await navigator.serviceWorker.getRegistration('/service-worker-custom.js');
    if (reg && reg.pushManager) {
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        console.log('User unsubscribed from push notifications');
        // Здесь можно отправить запрос на сервер для удаления подписки
        const endpoint = `${backendUrl}/api/notifications/unsubscribe-web-push/`;
        await fetchWithAuth(endpoint, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ registration_id: sub.endpoint }),
        });
      } else {
        console.warn('No push subscription found');
      }
    } else {
      console.warn('Push manager not available');
    }
  }
}

export async function checkPushSubscription() {
  if (window.Notification && Notification.permission === 'granted');
    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.getRegistration('/service-worker-custom.js');
      if (reg && reg.pushManager) {
        const sub = await reg.pushManager.getSubscription();
        if (sub) {
          const endpoint = `${backendUrl}/api/notifications/check-web-push-subscription/?registration_id=${encodeURIComponent(sub.endpoint)}`;
          const response = await fetchWithAuth(endpoint, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          });
          if (response.ok) {
            const data = await response.json();
            console.log('Push subscription check response:', data);
            if (data && data.subscribed !== undefined) {
              // Проверяем статус подписки
              if (data.subscribed) {
                console.log('User is subscribed to push notifications');
                return true;
              } else {
                console.warn('User is not subscribed to push notifications');
                return false;
              }
            }
          } else {
            console.error('Failed to check push subscription:', response.statusText);
          }
        }
        console.warn('No push subscription found');
        return false;
      }
      console.warn('Push manager not available');
      return false;
    }
  console.warn('Service Worker not supported');
  return false;
}


